
  
  export const basicauth={
    username: "info@seobix@bumppy@goseo",
    password: "goseo@bumppy@seobix@info",
  
  }
  
  export const billpunchbasicauth={
    username: "abhijeet@bumppy",
    password: "password",
  
  }
  export const apibasicauth={
    username: "BUMPPY_SSO_SgLjvARJ5LbX",
    password: "tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq",
  
  }